import { render, staticRenderFns } from "./IndicadoresResumoPreditiva.vue?vue&type=template&id=7daa9224&scoped=true&"
import script from "./IndicadoresResumoPreditiva.vue?vue&type=script&lang=js&"
export * from "./IndicadoresResumoPreditiva.vue?vue&type=script&lang=js&"
import style0 from "./IndicadoresResumoPreditiva.vue?vue&type=style&index=0&id=7daa9224&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7daa9224",
  null
  
)

export default component.exports